{
  "PROFILE_SETTINGS": {
    "LINK": "Profile Settings",
    "TITLE": "Profile Settings",
    "BTN_TEXT": "Update Profile",
    "DELETE_AVATAR": "Delete Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar has been deleted successfully",
    "AVATAR_DELETE_FAILED": "There is an error while deleting avatar, please try again",
    "UPDATE_SUCCESS": "Your profile has been updated successfully",
    "PASSWORD_UPDATE_SUCCESS": "Your password has been changed successfully",
    "AFTER_EMAIL_CHANGED": "Your profile has been updated successfully. To complete the email change, check your new email inbox and confirm the change. Then log in with your new email.",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Email signature picture",
        "HINT": "Used in email signatures. {'{{'}email_signature_picture{'}}'} is replaced with the URL of this picture (not an image tag) — use it as an image source (the src of an img tag) in your signature or the inbox signature. If not set, nothing is inserted.",
        "DELETE_SUCCESS": "Email signature picture has been deleted successfully",
        "DELETE_FAILED": "There was an error deleting the email signature picture, please try again"
      },
      "AVATAR": "Profile Image",
      "ERROR": "Please fix form errors",
      "REMOVE_IMAGE": "Remove",
      "UPLOAD_IMAGE": "Upload image",
      "UPDATE_IMAGE": "Update image",
      "PROFILE_SECTION": {
        "TITLE": "Profile",
        "NOTE": "Your email address is your identity and is used to log in."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Customize the look and feel of your dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Dashboard language",
          "NOTE": "Override the account language for your own dashboard. Leave empty to use the account default.",
          "USE_ACCOUNT_DEFAULT": "Use account default",
          "API_SUCCESS": "Your dashboard language has been updated successfully",
          "API_ERROR": "There is an error while updating the dashboard language, please try again"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Message Language",
          "NOTE": "Choose whether to display original messages or their translations",
          "ORIGINAL": "Original",
          "TRANSLATED": "Translated"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Paste Behavior",
          "NOTE": "Choose how pasted content should be processed when composing messages",
          "UPDATE_SUCCESS": "Your paste settings have been updated successfully",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Preserve all formatting",
              "DESCRIPTION": "Keep all formatting including tables, styles, and other HTML elements when pasting content."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Text with links only",
              "DESCRIPTION": "Convert to plain text but preserve clickable links when pasting content."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Plain text only",
              "DESCRIPTION": "Remove all formatting and convert to plain text when pasting content."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Reply box height",
          "NOTE": "Set the minimum height of the reply box as a percentage of the screen height. Applies only to email conversations.",
          "UPDATE_SUCCESS": "Your reply box height setting has been updated successfully",
          "PERCENT_LABEL": "Height (% of screen height)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Default",
              "DESCRIPTION": "The reply box starts small and grows as you type."
            },
            "CUSTOM": {
              "HEADING": "Custom",
              "DESCRIPTION": "The reply box is always at least the chosen percentage of the screen height."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Auto-navigate to next conversation",
        "NOTE": "Automatically switch to the next open conversation after resolving the current one",
        "UPDATE_SUCCESS": "Auto-navigation setting updated successfully"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Email preview format in conversation list",
        "NOTE": "Choose what is shown in the conversation list for conversations from email inboxes",
        "SUBJECT": "Subject",
        "SUBJECT_WITH_NOTE": "Subject and last message if it is an internal note",
        "UPDATE_SUCCESS": "Email preview setting updated successfully"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Disable keyboard shortcuts",
        "NOTE": "Turn off all keyboard shortcuts across the application",
        "UPDATE_SUCCESS": "Keyboard shortcuts setting updated successfully"
      },
      "FOLDER_ORDER": {
        "TITLE": "Folder Order",
        "NOTE": "Customize the order in which folders (custom views) appear in the sidebar. Drag and drop to reorder.",
        "NO_FOLDERS": "No custom folders found. Create folders to organize your conversations."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Sidebar Configuration",
        "NOTE": "Customize which sections appear in the conversations sidebar.",
        "SAVE_BUTTON": "Save Configuration",
        "UPDATE_SUCCESS": "Sidebar configuration updated successfully",
        "UPDATE_ERROR": "There was an error updating the sidebar configuration, please try again",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "All Conversations",
          "ALL_CONVERSATIONS_DESC": "Show the All Conversations menu item in the sidebar",
          "INBOX": "Inbox",
          "INBOX_DESC": "Show the main inbox with unread notifications",
          "CONVERSATION_GROUPS": "Mentions and Unattended",
          "CONVERSATION_GROUPS_DESC": "Show Mentions, and Unattended conversation groups",
          "FOLDERS": "Folders",
          "FOLDERS_DESC": "Show custom views (folders) for organized conversations",
          "TEAMS": "Teams",
          "TEAMS_DESC": "Show conversations filtered by team assignments",
          "CHANNELS": "Inboxes",
          "CHANNELS_DESC": "Show conversations filtered by inbox",
          "LABELS": "Labels",
          "LABELS_DESC": "Show conversations filtered by labels"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Phone settings",
        "NOTE": "Enter login credentials to your PBX system.",
        "USERNAME": "User name",
        "PASSWORD": "Password",
        "SUBMIT": "Save",
        "USERNAME_INVALID": "The user name can only contain letters, digits and . _ - + — no spaces and no e-mail address.",
        "API": {
          "USERNAME_INVALID": "The user name is not a valid SIP user name. Use only letters, digits and . _ - + — no spaces and no e-mail address.",
          "USERNAME_TAKEN": "This user name is already used by another agent in this account."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personal message signature",
        "DESCRIPTION": "Create a unique message signature to appear at the end of every email you send. You can also include an inline image.",
        "NOTE": "This settings will be applied only when there is not HTML signature set on inbox.",
        "BTN_TEXT": "Save message signature",
        "API_ERROR": "Couldn't save signature! Try again",
        "API_SUCCESS": "Signature saved successfully",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Message Signature",
        "ERROR": "Message Signature cannot be empty",
        "PLACEHOLDER": "Insert your personal message signature here."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Password",
        "NOTE": "Updating your password would reset your logins in multiple devices.",
        "BTN_TEXT": "Change password"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Access Token",
        "NOTE": "This token can be used if you are building an API based integration",
        "COPY": "Copy",
        "REGENERATE": "Regenerate",
        "REGENERATE_SUCCESS": "Access token regenerated successfully. Please update any integrations using the old token.",
        "REGENERATE_CONFIRM_TITLE": "Regenerate access token?",
        "REGENERATE_CONFIRM_MESSAGE": "This will invalidate the current token. Any integrations using the old token will stop working."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome Extension",
        "NOTE": "Install our chrome extension to get rich notifications about incoming phone calls.",
        "INSTALL_BUTTON": "Install extension",
        "ALREADY_INSTALLED": "Extension installed"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "None",
          "MINE": "Assigned",
          "ALL": "All",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "None",
          "ASSIGNED": "Assigned Conversations",
          "ALL_CONVERSATIONS": "All Conversations"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Email Notifications",
        "NOTE": "Update your email notification preferences here",
        "CONVERSATION_ASSIGNMENT": "Send email notifications when a conversation is assigned to me",
        "CONVERSATION_CREATION": "Send email notifications when a new conversation is created",
        "CONVERSATION_MENTION": "Send email notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "Email",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in a conversation without available agent",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you're able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Allow push notifications while you're on a call",
        "TEST_PUSH": "Test",
        "TESTING": "Testing...",
        "TEST_PUSH_DESCRIPTION": "Send test notifications to verify your setup",
        "TEST_NOTIFICATION_ERROR": "Failed to send test notification. Please try again.",
        "TEST_LOCAL_TITLE": "Test Notification (Local)",
        "TEST_LOCAL_BODY": "This is a local browser notification. If you see this, browser notifications are working!"
      },
      "API": {
        "UPDATE_SUCCESS": "Your notification preferences are updated successfully",
        "UPDATE_ERROR": "There is an error while updating the preferences, please try again"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push Notifications",
        "NOTE": "Update your push notification preferences here",
        "CONVERSATION_ASSIGNMENT": "Send push notifications when a conversation is assigned to me",
        "CONVERSATION_CREATION": "Send push notifications when a new conversation is created",
        "CONVERSATION_MENTION": "Send push notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "You have enabled push for this browser.",
        "REQUEST_PUSH": "Enable push notifications",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profile Image"
      },
      "NAME": {
        "LABEL": "Your full name",
        "ERROR": "Please enter a valid full name",
        "PLACEHOLDER": "Please enter your full name"
      },
      "DISPLAY_NAME": {
        "LABEL": "Display name",
        "ERROR": "Please enter a valid display name",
        "PLACEHOLDER": "Please enter a display name, this would be displayed in conversations"
      },
      "POSITION": {
        "LABEL": "Position",
        "ERROR": "Please enter a valid position",
        "PLACEHOLDER": "Please enter your position"
      },
      "CUSTOM_LINE": {
        "LABEL": "Custom line",
        "ERROR": "Please enter a valid custom line",
        "PLACEHOLDER": "Please enter your custom line"
      },
      "AVAILABILITY": {
        "LABEL": "Availability",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Busy",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL": {
        "LABEL": "Your email address",
        "ERROR": "Please enter a valid email address",
        "PLACEHOLDER": "Please enter your email address, this would be displayed in conversations"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Current password",
        "ERROR": "Please enter the current password",
        "PLACEHOLDER": "Please enter the current password"
      },
      "PASSWORD": {
        "LABEL": "New password",
        "ERROR": "Please enter a password of length 6 or more",
        "PLACEHOLDER": "Please enter a new password"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirm new password",
        "ERROR": "Confirm password should match the password",
        "PLACEHOLDER": "Please re-enter your new password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Change",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Report a bug",
    "SELECTOR_SUBTITLE": "Select an account from the following list",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Report a bug",
    "DESCRIPTION_LABEL": "Issue Description",
    "DESCRIPTION_PLACEHOLDER": "Describe the issue you encountered...",
    "SUBMIT": "Submit report",
    "SUBMITTING": "Submitting...",
    "CANCEL": "Cancel",
    "SUCCESS": "Bug report submitted successfully. Thank you!",
    "ERROR": "Failed to submit bug report. Please try again.",
    "VALIDATION_ERROR": "Please describe the issue before submitting"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "days trial remaining.",
    "TRAIL_BUTTON": "Buy Now",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copy",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Copied to clipboard"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Download",
      "UPLOADING": "Uploading...",
      "INSTAGRAM_STORY_UNAVAILABLE": "This story is no longer available.",
      "RECORDING_UNAVAILABLE": "This recording is no longer available.",
      "DELETE_RECORDING": {
        "BUTTON": "Delete call recording",
        "TITLE": "Delete the call recording?",
        "DESCRIPTION": "All recordings of this call will be deleted permanently from the phone system and cannot be restored. The transcript and summary of the call stay.",
        "CONFIRM": "Delete",
        "SUCCESS": "Call recording deleted",
        "ERROR": "Could not delete the call recording. Please try again."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Submit"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verifying...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Add Inbox"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Conversations",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "All Conversations",
    "MENTIONED_CONVERSATIONS": "Mentions",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Reports",
    "SETTINGS": "Settings",
    "CONTACTS": "Contacts",
    "DATA_ASSISTANT": "Data Assistant",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Home",
    "AGENTS": "Agents",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "WhatsApp templates",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Inboxes",
    "NOTIFICATIONS": "Notifications",
    "CANNED_RESPONSES": "Canned Responses",
    "INTEGRATIONS": "Integrations",
    "PROFILE_SETTINGS": "Profile Settings",
    "ACCOUNT_SETTINGS": "Account Settings",
    "APPLICATIONS": "Applications",
    "LABELS": "Labels",
    "CUSTOM_ATTRIBUTES": "Custom Attributes",
    "AUTOMATION": "Automation",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Conversations",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campaigns",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agents",
    "REPORTS_LABEL": "Labels",
    "REPORTS_INBOX": "Inbox",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Phone",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Overview",
    "WALLBOARD_QUEUES": "Queues",
    "WALLBOARD_AGENTS": "Agent Overview",
    "DATA_ASSISTANT": "Data Assistant",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Reports",
    "NO_WAITING_CALLERS": "no callers waiting",
    "WAITING_CALLERS": "{count} callers waiting",
    "SET_AVAILABILITY_TITLE": "Set yourself as",
    "SET_YOUR_AVAILABILITY": "Set your availability",
    "AVAILABILITY_IMPERSONATING": "Locked while logged in as this user",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "New conversation",
    "DRAFT": "Draft",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Overview",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "DICTIONARY": "Dictionary",
      "SETTINGS": "Settings"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Read docs"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blocked domains and contacts",
    "DESCRIPTION": "List of blocked email domains for this account.",
    "NO_BLOCKED_DOMAINS": "No blocked domains found.",
    "BLOCKED_CONTACTS_BTN": "Blocked Contacts"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Need help?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "Chat with us"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uh oh! We could not find any accounts. Please create a new account to continue.",
    "NEW_ACCOUNT": "New Account",
    "SELECTOR_SUBTITLE": "Create a new account",
    "API": {
      "SUCCESS_MESSAGE": "Account created successfully",
      "EXIST_MESSAGE": "Account already exists",
      "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Company Name",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Submit",
      "CANCEL": "Cancel"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Open conversation",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Go to Settings",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "AI assist",
      "AI_ASSIST_GRAMMAR": "Fix grammar",
      "AI_ASSIST_UNIFY_LANG": "Unify message language"
    }
  }
}
